package model

sealed class StatusResult {
    object Success : StatusResult()
    data class Failure(val status: String) : StatusResult()
}